export { default as loadCities } from './loadCities';

export type { LoadCitiesFunction, LoadCitiesPayload } from './loadCities.type';
